<template>
  <b-modal :id="`ModalRemoverCenario${id}`">
    <Header mini titulo="REMOVER CENÁRIO" icone="trash" cor="vermelho" slot="modal-header" />
    <template>
      <div class="modal-corpo">
        Tem certeza que deseja remover seu cenário?
      </div>
    </template>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="cancelar"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="remover"
        icone="check"
        :click="handleClick"
        cor="vermelho"
      />
    </template>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";

export default {
  name: "ModalRemover",
  components: {
    BotaoPadrao,
    Header
  },
  props: {
    removeCenario: Function,
    id: Number
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },

  methods: {
    handleKey(event) {
      let modal = document.getElementById(`ModalRemoverCenario${this.id}`);
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.removeCenario(this.id);
          this.$root.$emit("bv::hide::modal", `ModalRemoverCenario${this.id}`);
        }
      }
    },
    handleClick() {
      this.removeCenario(this.id);
      this.$root.$emit("bv::hide::modal", `ModalRemoverCenario${this.id}`);
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", `ModalRemoverCenario${this.id}`);
    }
  }
};
</script>

<style lang="scss">
.modal-cabecalho {
  display: flex;
  flex-direction: column;
  align-items: center !important;
  justify-content: center;
}
.modal-cabecalho-interno {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modal-icone-remover {
  font-size: 40px;
  margin: 5px 0;
  color: #cf2043;
}
.modal-corpo {
  text-align: center;
}
.botao-modal {
  margin: 0 0 0 10px !important;
}
</style>
